/* eslint-disable no-useless-escape */

export const eightCharPass = '^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$';
